export const listSubscriptions = `
   query listSubscriptions($filter: SubscriptionsFilterInput, $limit: Int, $nextToken: String) {
       listSubscriptions(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              created
              customerId
              currency
              description
              items {
                id
                price
                quantity
              }
              status
              startDate
           }
           nextToken
       }
   }
`;

export const getSubscription = `
   query getSubscription($id:ID!) {
       getSubscription(id:$id) {
            id
            created
            customerId
            currency
            description
            items {
                id
                price
                quantity
            }
            status
            startDate
       } 
}`;
